import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import MapSearchComponent from "./searchComponent";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import { showSnackbar } from "../../../../app/slices/common/customSnackBar/customSnackbarSlice";
import { getDecryptedToken } from "../../../../app/auth/authHandler";
import { useAppDispatch, useAppSelector } from "../../../../app/redux/hooks";

import useLocationHook from "../../../../app/hook/locationFinderHook";

import { useEffect, useState } from "react";
import { getAddressListAsync } from "../../../../app/slices/addressSlice/ProfileSlice";
import useLocationFinder from "../../../../app/hook/locationNameFinderWithLonAndLat";
import { SavedAddressSkeleton } from "./skeleton/savedAddressSkeleton";
import {
  setAddressType,
  setLocationAsync,
  setLocationVerifiedStatus,
} from "../../../../app/slices/common/locationSlice/locationSlice";
import React from "react";
import CustomDialog from "../../../components/custom/dialog";
import { LocationConfirmationPrompt } from "./LocationConfirmationPromt";
import { getAddressChangeAsync } from "../../../../app/slices/checkoutSlice/CheckoutSlice";

export const LocationComponent = ({ onCloseModal }: any) => {
  const dispatch = useAppDispatch();

  const { addressList } = useAppSelector((state) => state?.AddressState);
  const location = useAppSelector((state) => state.locationState);
  const [selectedAddress, setSelectedAddress] = useState("");
  const [lat, setLat] = useState<any>(null);
  const [lng, setLng] = useState<any>(null);
  const [selectedId, setSelectedId] = useState("");
  const [modalType, setModalType] = React.useState("");
  const [modalOptions, setModalOptions] = useState<any>(null);
  const [addressValue, setAddressValue] = useState<any>("");
  const locationVerified = useAppSelector(
    (state) => state.locationState.locationVerified,
  );
  const { addTocart } = useAppSelector((state) => state.CartState);
  const cartData = addTocart?.data;
  const onOpenModal = (type: string, options?: any) => {
    setModalType(type);
    setModalOptions(options);
  };
  const onCloseModal1 = () => {
    setModalType("");
  };
  const promptClose = () => {
    setModalType("");
  };
  const onModalCloseCallback = (event: any) => {
    if (event === "confirmed") {
      if (addressValue) handleChangeAddress(addressValue);
      else fetchLocation();
    }
  };
  useLocationFinder(lat, lng);
  const handleRadioChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    value: any,
  ) => {
    setAddressValue(value);
    if (cartData?.length !== 0) {
      dispatch(getAddressChangeAsync({ address_id: value?.id })).then(
        (response: any) => {
          if (
            response?.payload?.data?.delivery_fee_change &&
            response?.payload?.data?.proceed
          ) {
            onOpenModal("locationConfirmation", {
              message: response?.payload?.data?.message,
              isDeliveryChargeChangeOnly: true,
            });
          } else if (response?.payload?.data?.proceed) {
            handleChangeAddress(value);
          } else {
            onOpenModal("locationConfirmation", {
              message: response?.payload?.data?.message,
            });
          }
        },
      );
    } else {
      handleChangeAddress(value);
    }
  };

  const handleChangeAddress = (changeValue: any) => {
    setSelectedId(changeValue?.id); // Set the selected id
    setSelectedAddress(changeValue?.address_type); // Update the selected address
    setLat(Number(changeValue.latitude));
    setLng(Number(changeValue.longitude));
    dispatch(setAddressType(changeValue?.address_type));
    let payload: any = {
      latitude: Number(changeValue.latitude),
      longitude: Number(changeValue.longitude),
      address_id: Number(changeValue.id),
    };
    const aId = localStorage.getItem("aId");
    const accessToken = getDecryptedToken();
    if (aId && accessToken == null) {
      payload.anonymous_id = aId;
    }
    dispatch(setLocationAsync(payload)).then((response: any) => {
      if (response?.payload?.data?.location?.anonymous_id) {
        localStorage.setItem(
          "aId",
          response?.payload?.data?.location?.anonymous_id,
        );
      }
      // setAddressValue("");
      // if (response?.payload?.data?.location?.shop == null) {
      // dispatch(setLocationVerifiedStatus("failed"));
      // onOpenModal("locationConfirmation");
      // dispatch(
      //   showSnackbar({
      //     message: "Location not serviceable",
      //     severity: "error",
      //     autoHide: 3000,
      //   })
      // );
      // }
      if (response?.payload?.data?.location) {
        dispatch(setLocationVerifiedStatus("success"));
        window.location.href = "/shopnow/";
        onCloseModal();
        dispatch(
          showSnackbar({
            message: "Location added successfully",
            severity: "success",
            autoHide: 3000,
          }),
        );
      } else {
        dispatch(
          showSnackbar({
            message: "Please try again later.",
            severity: "error",
            autoHide: 3000,
          }),
        );
      }
    });
  };
  const { fetchLocation, permissionDenied, modalOpen } = useLocationHook();
  useEffect(() => {
    if (modalOpen) {
      onCloseModal();
    }
  }, [modalOpen]);
  const clickFindLocation = () => {
    dispatch(setAddressType(""));
    setSelectedId("");
    if (permissionDenied) {
      dispatch(
        showSnackbar({
          message:
            "Location access was denied. Please enable location services in your browser settings and reload.",
          severity: "info",
        }),
      );
    } else {
      if (cartData?.length !== 0) {
        onOpenModal("locationConfirmation");
      } else {
        fetchLocation();
      }
    }
  };
  useEffect(() => {
    const accessToken = getDecryptedToken();

    setSelectedId(location?.locationGot?.address_id);
    if (accessToken) {
      dispatch(getAddressListAsync());
    }
  }, [dispatch, location?.locationGot?.address_id]);

  return (
    <>
      <div className="tf-search-content">
        <div className="tf-mini-cart-bottom">
          <div className="tf-mini-cart-bottom-wrap">
            <div>
              <MapSearchComponent onCloseModal={onCloseModal} />
            </div>

            <a href="#" className="w-100">
              <div className="tf-btn mt-4 radius-3 w-100 justify-content-start orange-b btn-add-note">
                <div className="pe-3">
                  <GpsFixedIcon color="secondary" />
                </div>
                <div onClick={clickFindLocation}>
                  Get current location
                  <br />
                  <span className="fw-4 fs-12">Using GPS</span>
                </div>
              </div>
            </a>

            {addressList?.loader ? (
              <SavedAddressSkeleton />
            ) : (
              addressList?.data?.length > 0 && (
                <div className="card mt-4">
                  <div className="card-body">
                    <h4 className="fs-16 fw-6 mb-3">Saved Addresses</h4>
                    {addressList?.data?.map((item: any, index: number) => {
                      return (
                        <RadioGroup
                          value={selectedId}
                          onChange={(e) => {
                            handleRadioChange(e, item);
                          }}
                          key={index}
                        >
                          <div key={index} className="row">
                            {index > 0 && <hr />}

                            <FormControlLabel
                              value={item?.id}
                              control={
                                <Radio
                                  color="secondary"
                                  checked={item.id === selectedId}
                                />
                              }
                              label={
                                <div className="row">
                                  <div className="col-md-1">
                                    {/* {item?.address_type === "home" ? (
                                  <HomeOutlinedIcon />
                                ) : (
                                  <WorkOutlineOutlinedIcon />
                                )} */}
                                  </div>
                                  <div className="col-md-11">
                                    <div>
                                      <p>
                                        <b>
                                          {item?.address_type?.toUpperCase()}
                                        </b>
                                      </p>
                                      <p className="mb-2">
                                        {`${item?.flat_no}, ${item?.landmark}`}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              }
                              className="col-md-12"
                            />
                          </div>
                        </RadioGroup>
                      );
                    })}
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
      <CustomDialog
        component={
          <LocationConfirmationPrompt
            onClose={promptClose}
            onModalCloseCallback={onModalCloseCallback}
            isFromCheckout={false}
            message={modalOptions?.message}
            isDeliveryChargeChangeOnly={
              modalOptions?.isDeliveryChargeChangeOnly
            }
          />
        }
        title=""
        openDialog={modalType === "locationConfirmation"}
        handleCloseDialog={promptClose}
        modalPlace="center"
      />
    </>
  );
};
